"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
// Export your package's public API here
__exportStar(require("./api/request-helpers"), exports);
__exportStar(require("./app-context/client"), exports);
__exportStar(require("./app-context/javascript-response"), exports);
__exportStar(require("./app-context/resolvers/header-and-footer-data"), exports);
__exportStar(require("./app-context/resolvers/ud-data"), exports);
__exportStar(require("./app-context/resolvers/utils"), exports);
__exportStar(require("./configs/next.config.env"), exports);
__exportStar(require("./configs/next.config.i18n"), exports);
__exportStar(require("./constants"), exports);
__exportStar(require("./pages/disallow-slug"), exports);
__exportStar(require("./shims/ud-data"), exports);
//# sourceMappingURL=index.js.map